import axios from 'axios';
import API from '../config/api';
import { resHandle } from '../helper';

export const carFeatureListService = params => axios.get(API.CAR_FEATURE_LIST + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const carFeatureByIdService = params => axios.get(API.CAR_FEATURE_BY_ID + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const carFeatureDropdownService = params => axios.get(API.CAR_FEATURE_DROPDOWN + params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const carFeatureCreateService = params => axios.post(API.CREATE_CAR_FEATURE, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const carFeatureUpdateService = params => axios.post(API.UPDATE_CAR_FEATURE, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});

export const carFeatureDeleteService = params => axios.post(API.DELETE_CAR_FEATURE, params).then(res => {
    let { status, data } = resHandle(res);
    return { status, data };
});
